import type { MergeExclusive } from "type-fest";
import type {
    CreateSwishPaymentRequestParams_EFlow,
    SwishPaymentRequest_EFlow,
} from "./e-flow/swish-payment-request-e-flow";
import type {
    CreateSwishPaymentRequestParams_MFlow,
    SwishPaymentRequest_MFlow,
} from "./m-flow/swish-payment-request-m-flow";

type SwishPaymentRequest =
    | SwishPaymentRequest_EFlow
    | SwishPaymentRequest_MFlow;

const createSwishPaymentRequest = (
    params: MergeExclusive<
        CreateSwishPaymentRequestParams_EFlow,
        CreateSwishPaymentRequestParams_MFlow
    >,
): SwishPaymentRequest => {
    return {
        ...params,
        currency: "SEK",
    };
};

export { createSwishPaymentRequest };
export type { SwishPaymentRequest };
